import module from 'viaticos/module.js'

export class ViaticosViaticoDevolucionesInformacionService {
  contrustor ($http) {
    this.$http = $http
  }

  post (folio, files) {
    let data = new FormData()
    files.forEach(function (item, index) {
      data.append('archivo_' + index, item)
    })
    return this.$http.post('api/viaticos/viaticos/viatico/devoluciones/informacion', data, {
      params: {
        folio: folio,
      },
    })
  }
}

module.service('ViaticosViaticoDevolucionesInformacionService', ViaticosViaticoDevolucionesInformacionService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Viaticos/Viatico/Devoluciones/Informacion.js